<style src="./GenresList.scss" lang="scss"></style>

<template lang="pug">
  section.genres-list(
    v-esc='hideGenresList'
    :class='{ "is-loading": loading }'
  )
    header.genres-list__header
      h2.genres-list__title {{ genresList.title }}
      button.genres-list__close(
        @click='hideGenresList'
        area-label="Закрыть"
      )
        Icon( name='close' )
    .genres-list__body
      ul.genres-list__sections
        li.genres-list__section(
          v-for='direction in directions'
          v-if='direction.items.length > 0'
          :key='direction.name'
          :class='{ "is-hidden": hiddenItemsMap[direction.id] }'
        )
          .genres-list__subheader(
            @click='toggleItems(direction.id)'
          )
            router-link.genres-list__subtitle(
              :to='`/directions/${direction.id}?target=${genresList.type}`'
            ) {{ direction.name }}
          ul.genres-list__items
            li.genres-list__item(
              v-for='(genreId, index) in direction.items'
              :key='genreId'
              :class='{ "is-current": isCurrent(genreId) }'
            )
              router-link.genres-list__link(
                :to='`/genres/${genreId}/${genresList.type}`'
              ) {{ getName(genreId) }}

      Loader(
        v-if='loading'
        type='component'
      )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import Icon from "@/components/Icon/Icon";
import Loader from "@/components/Loader/Loader";

import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      directions: [],
      hiddenItemsMap: {}
    };
  },
  components: {
    Icon,
    Loader
  },
  computed: {
    ...mapGetters({
      genres: "genres/genres",
      genresList: "page/genresList"
    })
  },
  methods: {
    ...mapActions({
      hideGenresList: "page/hideGenresList"
    }),
    getName(id) {
      return this.genres[id] && this.genres[id].name;
    },
    isCurrent(id) {
      return this.genresList.title === this.getName(id);
    },
    toggleItems(directionId) {
      this.hiddenItemsMap = {
        ...this.hiddenItemsMap,
        [directionId]: !this.hiddenItemsMap[directionId]
      };
    }
  },
  async created() {
    this.loading = true;

    const { directions } = await PageLoader.getDirections();

    this.directions = directions;
    this.genresIds = directions.reduce((ids, d) => [...ids, ...d.items], []);

    await PageLoader.getGenres({ ids: this.genresIds });

    this.loading = false;
  }
};
</script>
